<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-if="userData.permissions['others'] == 1">
      <div class="row">
        <div class="col-12">
          <div class="card shadow-lg">
            <div class="card-body">
              <div class="row">
                <b-form-group class="col-md-3" label="Term">
                  <v-select
                    :options="schoolterms"
                    placeholder="Select Term"
                    v-model="schoolterm"
                    label="name"
                  ></v-select>
                </b-form-group>
                <b-form-group class="col-md-3" label="Year">
                  <v-select
                    :options="years"
                    placeholder="Select Year"
                    v-model="year"
                  ></v-select>
                </b-form-group>
                <div class="col-md-4 mt-md-4 mt-2 p-lg-0">
                  <b-button variant="primary" @click="FilterData()"
                    ><i class="mdi mdi-account-search"></i> Filter</b-button
                  >
                </div>
                <div class="d-flex justify-content-end">
                  <b-button v-b-modal.new-products size="sm" variant="primary"
                    ><i class="mdi mdi-plus"></i> Add Homework</b-button
                  >
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show
                      <b-form-select
                        class="form-select form-select-sm mx-1"
                        v-model="perPage"
                        size="sm"
                        :options="Options"
                      ></b-form-select>
                      entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                  >
                    <label class="d-inline-flex align-items-center">
                      Search:
                      <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                      ></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <b-table
                  :items="Items"
                  :fields="Fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="Filtered"
                  :busy="IsBusy"
                >
                  <template #table-busy
                    ><div class="text-center text-primary my-2">
                      <b-spinner
                        class="align-middle"
                        type="grow"
                        small
                      ></b-spinner>
                      <strong>No Data Found</strong>
                    </div></template
                  >
                  <template #cell(index)="data">
                    {{ data.index + 1 }}
                  </template>
                  <template #cell(schoolclass)="data">
                    {{ data.item.schoolclass.name }}
                  </template>
                  <template #cell(schoolterm)="data">
                    {{ data.item.schoolterm.name }}
                  </template>
                  <template #cell(schoolsubject)="data">
                    {{ data.item.subject.name }}
                  </template>
                  <template #cell(document)="data">
                    <div class="btn-group">
                      <b-button
                        @click="view(data.item)"
                        type="button"
                        class="btn-sm btn"
                        variant="success"
                        ><i class="mdi mdi-eye" style></i>View</b-button
                      >
                    </div>
                  </template>
                  <template #cell(addedby)="data">
                    {{ data.item.addedby }}
                  </template>
                  <template #cell(actions)="data">
                    <div class="btn-group">
                      <b-button
                        @click="
                          edit(
                            data.item.id,
                            data.item.schoolclass,
                            data.item.deadline,
                          )
                        "
                        type="button"
                        class="btn-sm btn"
                        variant="info"
                        v-b-modal.edit
                      >
                        <i class="mdi mdi-square-edit-outline"></i>
                      </b-button>
                      <b-button
                        @click="remove(data.item.id)"
                        type="button"
                        class="btn-sm btn"
                        variant="danger"
                        v-b-modal.delete
                      >
                        <i class="mdi mdi-trash-can"></i>
                      </b-button>
                    </div>
                  </template>
                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="List"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <b-modal
        id="new-products"
        centered
        title="New  Homework"
        title-class="font-18"
        hide-footer
      >
        <form @submit.prevent="addproducts">
          <div class="form-group mb-2">
            <label>Class</label>
            <multiselect
              v-model="schoolclass"
              label="name"
              :options="schoolclasses"
            ></multiselect>
            <label>Subject</label>
            <multiselect
              v-model="schoolsubject"
              label="name"
              :options="schoolsubjects"
            ></multiselect>
            <label>Deadline</label>
            <input
              v-model="deadline"
              type="date"
              :min="currentdate"
              class="form-control"
            />
            <label>Document</label>
            <input
              id="document"
              type="file"
              class="form-control"
              accept="application/pdf"
              @change="handleImage"
            />
          </div>
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('new-products')"
              >Close</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i> Submit</b-button
            >
          </div>
        </form>
      </b-modal>

      <b-modal
        id="edit-products"
        centered
        title="Edit  Homework Record"
        title-class="font-14"
        hide-footer
      >
        <form @submit.prevent="editproducts">
          <div class="form-group mb-2">
            <input v-model="id" type="hidden" />
            <label>Class</label>
            <multiselect
              v-model="schoolclass"
              label="name"
              :options="schoolclasses"
            ></multiselect>
            <label>Subject</label>
            <multiselect
              v-model="schoolsubject"
              label="name"
              :options="schoolsubjects"
            ></multiselect>
            <label>Deadline</label>
            <input
              v-model="deadline"
              type="date"
              :min="currentdate"
              class="form-control"
            />
          </div>
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('edit-products')"
              >Close</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i> Submit</b-button
            >
          </div>
        </form>
      </b-modal>

      <b-modal
        id="delete-products"
        centered
        title="Delete Homework"
        title-class="font-18"
        hide-footer
      >
        <form @submit.prevent="removeproducts">
          <input v-model="id" type="hidden" />
          Are you sure you want to delete the homework ?
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('delete-products')"
              >Close</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i> Submit</b-button
            >
          </div>
        </form>
      </b-modal>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <center>
              <span class="text-primary h4"
                >You have no permission to view the Dashboard.</span
              >
            </center>
            <img
              src="@/assets/images/profile-img.png"
              alt
              class="img-fluid"
            /><br /><br />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import {
  homeworksComputed,
  homeworksMethods,
  schoolclassComputed,
  schoolclassMethods,
  schoolsubjectMethods,
  schoolsubjectComputed,
  schooltermComputed,
  schooltermMethods,
} from "@/state/helpers";
import axios from "axios";
import Multiselect from "vue-multiselect";
import Layout from "../../layouts/main";

export default {
  page: {
    title: "Homework",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Homework ",
      items: [
        { text: "Dashboard", to: "/" },
        { text: " Homework", active: true },
      ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "id", label: "ID", visible: false },
        { key: "schoolclass", label: "Class", visible: true },
        { key: "schoolsubject", label: "Subject", visible: true },
        { key: "schoolterm", label: "Term", visible: true },
        { key: "year", label: "Year", visible: true },
        { key: "deadline", label: "Deadline", visible: true },
        { key: "document", label: "Document", visible: true },
        { key: "addedon", label: "Date added", visible: true },
        { key: "addedby", label: "Added by", visible: true },
        { key: "actions", label: "Actions", visible: true },
      ],
      id: "",
      schoolclass: "",
      deadline: "",
      document: "",
      schoolterm: "",
      schoolsubject: "",
      currentdate: new Date().toLocaleDateString("fr-CA"),
      year: new Date().getFullYear(),
    };
  },
  computed: {
    ...homeworksComputed,
    ...schoolclassComputed,
    ...schoolsubjectComputed,
    ...schooltermComputed,
    List() {
      return this.homeworks.length;
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.homeworks.map((d) => ({ ...d }));
    },
    IsBusy() {
      let a = false;
      if (this.homeworks.length > 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },
    years() {
      const currentYear = new Date().getFullYear();
      const startYear = currentYear - 10;
      const endYear = currentYear;
      const yearArray = [];
      for (let year = startYear; year <= endYear; year++) {
        yearArray.push(year);
      }
      return yearArray;
    },
  },
  mounted() {
    this.fetchHomeworks();
    this.fetchSchoolClasses();
    this.fetchSchoolSubjects();
    this.fetchSchoolTerms();
    this.TotalRows = this.homeworks.length;
    this.isBusy = false;
  },
  methods: {
    ...homeworksMethods,
    ...schoolclassMethods,
    ...schoolsubjectMethods,
    ...schooltermMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    edit(id, schoolclass, schoolsubject, deadline) {
      this.id = id;
      this.schoolclass = schoolclass;
      this.schoolsubject = schoolsubject;
      this.deadline = deadline;
      this.$bvModal.show("edit-products");
    },
    remove(id) {
      this.id = id;
      this.$bvModal.show("delete-products");
    },
    async addproducts() {
      let formData = new FormData();
      formData.append("schoolclass", this.schoolclass.id);
      formData.append("schoolsubject", this.schoolsubject.id);
      formData.append("deadline", this.deadline);
      formData.append("document", this.document);
      let url = "/addhomework";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchHomeworks();
          this.$bvModal.hide("new-products");
          this.$swal({
            title: "Success",
            text: " Added Successfully",
            icon: "success",
          });
        }
      });
    },
    async editproducts() {
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("schoolclass", this.schoolclass.id);
      formData.append("schoolsubject", this.schoolsubject.id);
      formData.append("deadline", this.deadline);
      let url = "/updatehomework";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchHomeworks();
          this.$bvModal.hide("edit-products");
          this.$swal({
            title: "Success",
            text: " Edited Successfully",
            icon: "success",
          });
        }
      });
    },
    async removeproducts() {
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/removehomework";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchHomeworks();
          this.$bvModal.hide("delete-position");
          this.$swal({
            title: "Success",
            text: " Deleted Successfully",
            icon: "success",
          });
        }
      });
    },
    getFiles(name) {
      let url = axios.defaults.baseURL;
      let imagelink = url.slice(0, -3) + "homeworks/" + name;
      return imagelink;
    },
    handleImage(e) {
      this.document = e.target.files[0];
    },
    view(item) {
      const fileUrl = this.getFiles(item.document);
      window.open(fileUrl, "_blank");
    },
    FilterData() {
      this.filterHomework({ schoolterm: this.schoolterm.id, year: this.year });
    },
  },
};
</script>
